import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    users: []
};
function userResource(data) {
    return {
        id: data.id,
        name: data.name,
        email: data.email,
        role: roleResource(data.role)
    };
}
function roleResource(data) {
    return {
        id: data.id,
        name: data.name
    };
}
export var UsersReducer = createSlice({
    name: 'users',
    initialState: initialState,
    reducers: {
        setUsers: function setUsers(state, payloadAction) {
            var data = [];
            payloadAction.payload.forEach(function (item) {
                data[item.id] = userResource(item);
            });
            state.users = data;
        },
        addUser: function addUser(state, payloadAction) {
            state.users.push(userResource(payloadAction.payload));
        },
        del: function del(state, id) {
            state.users = state.users.filter(function (item) {
                return item.id !== id.payload;
            });
        },
        update: function update(state, user) {
            state.users[user.payload.id] = userResource(user.payload);
        }
    }
});
var _UsersReducer$actions = UsersReducer.actions, setUsers = _UsersReducer$actions.setUsers, addUser = _UsersReducer$actions.addUser, del = _UsersReducer$actions.del, update = _UsersReducer$actions.update;
export { setUsers, addUser, del, update };
export default UsersReducer.reducer;
